
import React from 'react';

interface ProcessingIndicatorProps {
  isProcessing: boolean;
}

export const ProcessingIndicator = ({ isProcessing }: ProcessingIndicatorProps) => {
  if (!isProcessing) return null;
  
  return (
    <div className="flex justify-center py-8">
      <p className="text-muted-foreground">Processing file...</p>
    </div>
  );
};
